<template>
  <div>
    <v-dialog v-model="confirmar" persistent max-width="330">
      <v-card>
        <v-card-title>Eliminar</v-card-title>
        <v-card-text>Esta seguro que desea eliminar el telefono?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              eliminarTelefono();
              confirmar = false;
            "
            >Aceptar</v-btn
          >
          <v-btn
            color="red darken-1"
            text
            @click="
              confirmar = false;
              tel.teldescripcion = '';
              tel.teltelefono = '';
              tel.telid = 0;
            "
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card elevation="0" outlined v-if="efectorlogueado" class="mx-auto">
      <v-system-bar color="light-blue accent-1 py-5">
        <v-row no-gutters class="light-blue accent-1 ">
          <v-col cols="6" md="6">
            <h2>{{ efectorlogueado.RAZON_SOCI }}</h2>
          </v-col>
          <v-col cols="6" md="6">
            <h2>{{ efectorlogueado.nombreefector }}</h2>
          </v-col>
        </v-row>
      </v-system-bar>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="12">
            <h3 class="text-center">Datos de contacto</h3>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.nombre_contacto"
              label="Nombre Contacto"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.telefono_contacto"
              label="Telefono Contacto"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.mail_contacto"
              label="Email Contacto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="12">
            <v-divider></v-divider>
            <h3 class="text-center">Datos institucionales</h3>
          </v-col>

          <v-col cols="6" md="2">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.celular"
              label="Celular"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.TELEFONOS"
              label="Telefono"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="efectorlogueado.EMAIL"
              label="Email"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              hide-details
              :readonly="!modificar"
              :filled="!modificar"
              placeholder=" "
              outlined
              class="upperText"
              dense
              label="Pagina web"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-btn
              v-if="!modificar"
              fab
              small
              color="green"
              @click="modificar = true"
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="modificar"
              small
              fab
              color="blue"
              @click.prevent="guardar"
            >
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="12">
            <v-divider></v-divider>
            <h2 class="text-center mt-3">Otros Telefonos</h2>
          </v-col>
          <v-col cols="12" md="12">
            <v-row
              v-for="telefono in efectorlogueado.Telefonos_Efectores"
              :key="telefono.id"
            >
              <v-col cols="12" md="3" offset="3">
                <v-text-field
                  hide-details
                  class="upperText"
                  :readonly="tel.telid != telefono.id"
                  :filled="tel.telid != telefono.id"
                  dense
                  v-model="telefono.descripcion"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  hide-details
                  :readonly="tel.telid != telefono.id"
                  :filled="tel.telid != telefono.id"
                  dense
                  v-model="telefono.telefono"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn
                  fab
                  small
                  color="green"
                  v-if="tel.telid != telefono.id"
                  @click="tel.telid = telefono.id"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  small
                  fab
                  color="blue"
                  v-if="tel.telid == telefono.id"
                  @click="
                    tel.teldescripcion = telefono.descripcion;
                    tel.teltelefono = telefono.telefono;
                    guardarTelefono();
                  "
                >
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  color="red"
                  v-if="tel.telid != telefono.id"
                  @click="
                    tel.telid = telefono.id;
                    confirmar = true;
                  "
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="tel.telid == 0">
          <v-col cols="6" md="12">
            <v-divider></v-divider>
            <h2 class="text-center mt-3">Nuevo telefono</h2>
          </v-col>
          <v-col cols="6" md="3" offset="3">
            <v-text-field
              hide-details
              placeholder="WHATSAPP, CONTACTO, ETC"
              class="upperText"
              dense
              v-model="tel.teldescripcion"
              label="Descripcion"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="1">
            <v-text-field
              hide-details
              placeholder=" "
              dense
              v-model="tel.teltelefono"
              label="Telefono"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-btn small fab color="blue" @click="guardarTelefono">
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import API from "@/lib/API";
export default {
  data() {
    return {
      tel: {
        teldescripcion: "",
        teltelefono: "",
        telid: 0,
      },
      confirmar: false,
      modificar: false,
    };
  },
  computed: {
    ...mapState("micrositioefectores", ["Usuario"]),
    ...mapState("efectores", { efectorlogueado: "Seleccionado" }),
  },
  methods: {
    ...mapActions("efectores", { SeleccionarEfector: "select" }),
    ...mapActions("micrositioefectores", ["inicializar"]),
    guardar() {
      API.Efector.modificar(this.efectorlogueado);
      this.modificar = false;
    },
    async guardarTelefono() {
      if (this.tel.teldescripcion != "" && this.tel.teltelefono != "") {
        let tel = {
          id: this.tel.telid,
          id_efector: this.efectorlogueado.Id,
          descripcion: this.tel.teldescripcion,
          telefono: this.tel.teltelefono,
        };
        if (this.tel.telid == 0) {
          let nuevo = await API.Telefonos_Efectores.alta(tel);
          this.efectorlogueado.Telefonos_Efectores.push(nuevo);
        } else {
          await API.Telefonos_Efectores.modificar(tel);
        }
        this.tel.teldescripcion = "";
        this.tel.teltelefono = "";
        this.tel.telid = 0;
      }
    },
    async eliminarTelefono() {
      await API.Telefonos_Efectores.eliminar(this.tel.telid);
      this.efectorlogueado.Telefonos_Efectores = this.efectorlogueado.Telefonos_Efectores.filter(
        (x) => x.id != this.tel.telid
      );
      this.tel.teldescripcion = "";
      this.tel.teltelefono = "";
      this.tel.telid = 0;
    },
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario) {
        this.$router.push({ name: "Micrositio" });
      }
    }
    if (this.Usuario && !this.efectorlogueado) {
      let efector = await API.Efector.traerUno(this.Usuario.UserId);
      this.SeleccionarEfector(efector);
    }
  },
};
</script>

<style></style>
